import React from 'react';

import KeyChip from '@dashboard/components/KeyChip';
import { useWorkflowEventQuery } from '@dashboard/generated/wp/platform';
import { Box, Stack, Typography } from '@mui/material';

import WorkflowLinkButton from './WorkflowLinkButton';
import WorkflowNameField from './WorkflowNameField';

type Props = {
  id: string;
};
export default function TimelineHeader({ id }: Props) {
  const { data } = useWorkflowEventQuery({ variables: { id } });

  const model = data?.WorkflowEvent;
  if (model === undefined) {
    return null;
  }

  const workflowId = model.workflowId!;
  return (
    <Box sx={{ pb: 1.5 }}>
      <WorkflowNameField workflowId={workflowId} />
      <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5, mb: 1 }}>
        <Stack spacing={3} direction="row" alignItems="center" sx={{ minHeight: 26 }}>
          <Typography variant="body2" color="text.secondary">
            Run ID: {model.id}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Meta id: <KeyChip label={model.metaId ? model.metaId : '--'} />
          </Typography>
        </Stack>
        <WorkflowLinkButton workflowId={workflowId} />
      </Stack>
    </Box>
  );
}
